<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="menu-icon"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center d-flex flex-grow-1 d-lg">
      <div>
        <b-tooltip
          target="refresh_cache"
          triggers="hover"
          variant="primary"
        >
          Clear App Cache
        </b-tooltip>
        <div
          id="refresh_cache"
          @click="refreshCache"
        >
          <img
            class="cursor-pointer"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1wYWludGJydXNoIj48cGF0aCBkPSJNMTguMzcgMi42MyAxNCA3bC0xLjU5LTEuNTlhMiAyIDAgMCAwLTIuODIgMEw4IDdsOSA5IDEuNTktMS41OWEyIDIgMCAwIDAgMC0yLjgyTDE3IDEwbDQuMzctNC4zN2EyLjEyIDIuMTIgMCAxIDAtMy0zWiIvPjxwYXRoIGQ9Ik05IDhjLTIgMy00IDMuNS03IDRsOCAxMGMyLTEgNi01IDYtNyIvPjxwYXRoIGQ9Ik0xNC41IDE3LjUgNC41IDE1Ii8+PC9zdmc+"
          >
        </div>
      </div>
      &nbsp;
      <div class="d-none d-lg-flex">
        <b-tooltip
          target="support-icon"
          triggers="hover"
          variant="primary"
        >
          Customer Support
        </b-tooltip>
        <a
          id="support-icon"
          href="https://projects.curfox.com/login"
          target="_blank"
        >
          <img
            class="support-icon mr-1 ml-1"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1oZWxwLWNpcmNsZSI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiLz48cGF0aCBkPSJNOS4wOSA5YTMgMyAwIDAgMSA1LjgzIDFjMCAyLTMgMy0zIDMiLz48cGF0aCBkPSJNMTIgMTdoLjAxIi8+PC9zdmc+"
          >
        </a>
      </div>
    </div>
    <div
      class="bookmark-wrapper business-title align-items-center flex-grow-1 d-none d-lg-flex"
      style="z-index:-1"
    >
      <div>
        <b class="nav-text">{{ form.company_name }}</b>
      </div>
    </div>
    <div class="navbar-scrollable">
      <b-navbar-nav class="nav align-items-center ml-auto">
        <general-search />
        <blinking-tooltip />
        <resources-dropdown />
        <notification-dropdown />
        <banner-notification />
        <dark-toggler class="d-none d-lg-flex" />
        <!-- <locale /> -->
      </b-navbar-nav>
    </div>
    <div>
      <b-navbar-nav class="nav align-items-center ml-1 d-block d-lg-none">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user dropdown-no-scroll"
        >
          <template #button-content>
            <feather-icon
              icon="ChevronsDownIcon"
              class="responsive-icon"
            />
          </template>
          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="toggleTheme"
          >
            <feather-icon
              size="16"
              class="mr-50"
              :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
            />
            <span>{{ isDark ? 'Light Mode' : 'Dark Mode' }}</span>
          </b-dropdown-item>

          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            href="/resources"
            target="_blank"
          >
            <feather-icon
              size="16"
              icon="GlobeIcon"
              class="mr-50"
            />
            <span>Resources</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            href="https://projects.curfox.com/login"
            target="_blank"
          >
            <feather-icon
              size="16"
              icon="HelpCircleIcon"
              class="mr-50"
            />
            <span>Customer Support</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
    <div>
      <b-navbar-nav class="nav align-items-center ml-auto">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user dropdown-no-scroll"
        >
          <template #button-content>
            <b-avatar
              size="40"
              variant="light-primary"
              badge
              :src="currentUser && currentUser.profile_picture
                ? currentUser.profile_picture
                : require('@/assets/images/avatars/12-small.png')"
              class="badge-minimal mobile-avatar"
              badge-variant="success"
            />
          </template>
          <b-dropdown-item>
            <div class="d-flex align-items-center">
              <div class="avatar-wrapper mr-2">
                <b-avatar
                  size="45"
                  variant="light-primary"
                  badge
                  :src="currentUser && currentUser.profile_picture
                    ? currentUser.profile_picture
                    : require('@/assets/images/avatars/12-small.png')"
                  class="badge-minimal"
                  badge-variant="success"
                />

                <div
                  class="camera-overlay"
                  @click="changeAvatar"
                >
                  <CameraIcon />
                </div>
              </div>

              <!-- User details -->
              <div>
                <p class="user-name font-weight-bolder mb-0">
                  {{ currentUser ? currentUser.first_name : '' }}
                </p>

                <div class="user-details">
                  <span class="user-status d-block">
                    {{ currentUser ? currentUser.role.name : '' }}
                  </span>
                </div>

                <span
                  v-if="warehouseList.length === 1"
                  class="user-status"
                  style="margin-top:4px;"
                >
                  {{ warehouseList[0].name }}
                </span>

                <span
                  v-if="warehouseList.length > 1"
                  class="user-status"
                  style="margin-top:4px; cursor:pointer;"
                  @click="showWarehouseModal"
                >
                  {{ warehouseList.length }} Warehouses
                </span>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            :href="apkUrl"
            target="_blank"
          >
            <feather-icon
              size="16"
              icon="SmartphoneIcon"
              class="mr-50"
            />
            <span>Download Apk</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            :to="{ name: 'business-setting' }"
          >
            <feather-icon
              size="16"
              icon="UserIcon"
              class="mr-50"
            />
            <span>Profile</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="onClickLogout"
          >
            <feather-icon
              size="16"
              icon="LogOutIcon"
              class="mr-50"
            />
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
    <warehouse-modal ref="warehouse_modal" />
    <ProfilePhotoModal
      v-model="signatureOpen"
      :photo="currentUser && currentUser.profile_picture
        ? currentUser.profile_picture
        : require('@/assets/images/avatars/12-small.png')"
    />
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar, BTooltip, BDropdownDivider,
} from 'bootstrap-vue'
import {
  mapActions,
  mapGetters,
} from 'vuex'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import useJwt from '@/auth/jwt/useJwt'
// import Locale from '@/@core/layouts/components/app-navbar/components/Locale.vue'
import {
  appEnv, bucketUrl, tenant, apiUrl,
} from '@/constants/config'
import NotificationDropdown from '@/@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import GeneralSearch from '@/@core/layouts/components/app-navbar/components/GeneralSearch.vue'
import BlinkingTooltip from '@/@core/layouts/components/app-navbar/components/BlinkingTooltip.vue'
import BannerNotification from '@/@core/layouts/components/app-navbar/components/BannerNotification.vue'
import ResourcesDropdown from '@/@core/layouts/components/app-navbar/components/ResourcesDropdown.vue'
import WarehouseModal from '@/components/Warehouse/WarehouseModal.vue'
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { CameraIcon } from 'vue-feather-icons'
import ProfilePhotoModal from '@/components/Profile/ProfilePhotoModal.vue'

const ResourceRepository = RepositoryFactory.get('resource')
const BusinessRepository = RepositoryFactory.get('businessSetting')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    BTooltip,
    NotificationDropdown,
    // Locale,
    WarehouseModal,
    DarkToggler,
    GeneralSearch,
    BlinkingTooltip,
    ResourcesDropdown,
    BDropdownDivider,
    CameraIcon,
    ProfilePhotoModal,
    BannerNotification,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')

    const toggleTheme = () => {
      skin.value = isDark.value ? 'light' : 'dark'
    }

    return { isDark, toggleTheme }
  },
  mixins: [ErrorMessage],
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      bucketUrl,
      tenant,
      apiUrl,
      form: {},
      warehouseList: [],
      useJwt,
      appEnv,
      signatureOpen: false,
    }
  },
  computed: {
    apkUrl() {
      const appName = appEnv === 'production' ? tenant : `${tenant}dev`
      return `${bucketUrl}apk/app-${appName}-release.apk`
    },
    ...mapGetters(['currentUser']),
  },
  async mounted() {
    await this.fetchBusinessSettings()
    await this.fetchAssignedWarehouses()
    await this.fetchModules()
  },
  methods: {
    changeAvatar() {
      this.signatureOpen = true
    },
    ...mapActions(['logout']),
    async onClickLogout() {
      // eslint-disable-next-line no-underscore-dangle
      this.__clearCache()
      await this.logout()
    },
    async fetchAssignedWarehouses() {
      try {
        this.loading = true
        this.warehouseList = localStorage.getItem('assigned_warehouse_list') ? JSON.parse(localStorage.getItem('assigned_warehouse_list')) : (await ResourceRepository.getAssignedWarehousesNoPagination()).data.data
        if (!localStorage.getItem('assigned_warehouse_list')) localStorage.setItem('assigned_warehouse_list', JSON.stringify(this.warehouseList))
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async fetchBusinessSettings() {
      try {
        this.loading = true
        this.form = localStorage.getItem('businessSettings') ? JSON.parse(localStorage.getItem('businessSettings')) : (await BusinessRepository.getbusinessSettingsResource()).data.data
        if (!localStorage.getItem('businessSettings')) localStorage.setItem('businessSettings', JSON.stringify(this.form))
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async fetchModules() {
      try {
        this.loading = true
        const data = localStorage.getItem('module_data') ? JSON.parse(localStorage.getItem('module_data')) : (await ResourceRepository.getModules()).data.data
        if (!localStorage.getItem('module_data')) localStorage.setItem('module_data', JSON.stringify(data))
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    showWarehouseModal() {
      setTimeout(() => {
        document.body.click()
      }, 45)
      this.$refs.warehouse_modal.openModal()
    },
    refreshCache() {
      // eslint-disable-next-line no-underscore-dangle
      this.__clearCache()
      const { currentRoute } = this.$router
      if (currentRoute.name === 'Selected-main-operation' || currentRoute.name === 'Selected-warehouse-operation' || currentRoute.name === 'Selected-pickup-operation') {
        this.$router.go(-1)
      } else {
        window.location.reload()
      }
    },
  },
}
</script>

<style lang="css" scoped>
/* ===== Avatar hover camera icon (GLOBAL) ===== */
.avatar-wrapper {
  position: relative;
  width: 45px;
  height: 45px;
  cursor: pointer;
}

.camera-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-wrapper:hover .camera-overlay {
  opacity: 1;
}

.camera-overlay svg {
  width: 18px;
  height: 18px;
  stroke: #fff;
}

/* ===== Existing styles ===== */
.support-icon {
  margin-left: 5px;
}

.tracking-icon {
  margin-left: 4px;
}

.business-title {
  justify-content: flex-start;
  font-size: 20px;
  display: flex;
  align-items: center;
  pointer-events: none;
  min-width: 0;
  overflow: hidden;

  @media (max-width: 1300px) {
    display: none !important;
  }

  table {
    table-layout: fixed;
    width: 100%;
  }

  b.nav-text {
    display: block;
    overflow: hidden;
    white-space: nowrap;
  }
}

.navbar-scrollable {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  overflow: visible;

  .navbar-nav {
    flex-wrap: nowrap !important;
    overflow: visible;
  }
}

.resource-icon {
  width: 24px;
  height: 24px;
  margin: 0 3px;
}

.responsive-icon {
  width: 18px;
  height: 18px;
}

/* ===== Mobile styles ===== */
@media (max-width: 768px) {
  .navbar-scrollable {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    max-width: 100%;
    scrollbar-width: none;
  }

  .navbar-scrollable::-webkit-scrollbar {
    display: none;
  }

  .navbar-scrollable .navbar-nav {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  .navbar-nav .nav-item {
    flex-shrink: 0;
    margin-right: 10px;
  }

  .navbar-container {
    width: 100%;
  }

  .menu-icon,
  .navbar-container img,
  .navbar-container .file-icon,
  .navbar-container feather-icon {
    width: 15px;
    height: 15px;
    margin: 0 4px;
  }

  .mobile-avatar {
    width: 20px !important;
    height: 20px !important;
  }

  .b-tooltip {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
